import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

interface Props {
  showBackgroundImages?: boolean;
  onShowBackgroundImagesChange?: (show: boolean) => void;
  snapToAudio?: boolean;
  onSnapToAudioChange?: (snap: boolean) => void;
}

export default function ScrubberSettingsButton({
  showBackgroundImages,
  onShowBackgroundImagesChange,
  snapToAudio,
  onSnapToAudioChange,
}: Props) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<SettingsOutlinedIcon fontSize="small" />}
        onClick={() => setOpen(true)}
      >
        Settings
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="scrubber-settings-title">
        <DialogTitle id="scrubber-settings-title">Scrubber settings</DialogTitle>
        <DialogContent>
          <Stack
            spacing={1}
            sx={{
              pt: 0.5,
              minWidth: { sm: 360 },
              '& .MuiFormControlLabel-root': { m: 0 },
            }}
          >
            {onShowBackgroundImagesChange && (
              <FormControlLabel
                control={(
                  <Switch
                    checked={!!showBackgroundImages}
                    onChange={(event) => onShowBackgroundImagesChange(event.target.checked)}
                  />
                )}
                label="Show scrubber background images"
              />
            )}
            {onSnapToAudioChange && (
              <FormControlLabel
                control={(
                  <Switch
                    checked={!!snapToAudio}
                    onChange={(event) => onSnapToAudioChange(event.target.checked)}
                  />
                )}
                label="Snap trim handles to audio boundaries"
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Done</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
